export default {
  opportunities: (state) => state.opportunities,
  selectedAnalysisProducts: (state) => state.selectedAnalysisProducts,
  selectedBoostProducts: (state) => state.selectedBoostProducts,
}
